{ digitcertUrl, injectDigicert } = require('../../../other/digicert');

angular.module("avant.customer_applications.controllers").controller "CustomerApplicationsMixinCtrl", [
  "$rootScope", "$scope", "$location", "$timeout", "$modal", "$parse", "GoogleTagManagerService", "CustomerApplicationService", "ConfigService", "ApplicationService", "ProductService", "AuthenticationService", "TealiumService", "$filter", "$window", "$interval", "$controller", "$q", "$pusher", "ValidationsRequiredHelper", "AmountHelper",
  ($rootScope, $scope, $location, $timeout, $modal, $parse, GoogleTagManagerService, CustomerApplicationService, ConfigService, ApplicationService, ProductService, AuthenticationService, TealiumService, $filter, $window, $interval, $controller, $q, $pusher, ValidationsRequiredHelper, AmountHelper) ->

    applicationServiceDataMissing = () ->
      !ApplicationService.data?

    if page_titles = $scope.config?.custom_page_titles
      if title = page_titles[$scope.page] || page_titles['default']
        $rootScope.header = title

    $scope.showPartialApp = window.avantEnv.PARTIAL_APP_VIEW_ENABLED
    $scope.formWasAutofilled = false

    # This is used to display the partial app in the customer application when a new partner is being onboarded
    $scope.partialAppData = JSON.stringify(ApplicationService.data, null, 2) if $scope.showPartialApp

    $scope.productPrefix = if $scope.customer_application?.product_type && $scope.customer_application.product_type != 'installment'
      "#{$scope.customer_application.product_type}_"
    else
      ''

    $scope.application_view = ApplicationService.data?.config?.variant?.application_view
    $scope.spinnerUrl = require('@amount/frontend-styles/src/images/dec/dec-loading.svg')
    $scope.spinnerUrl2 = require('@amount/frontend-styles/src/images/icons/icon-map.svg') + '#icon-loading'
    $scope.dec_rates_arrow = require('@amount/frontend-styles/src/images/dec/dec-rates-arrow.svg')

    $scope.radioButtonSelectedValue = (val) ->
      if ['true', 'false'].includes(val)
        ['true', 'false'].indexOf(val) == 0
      else
        val

    $scope.loadPageConfig = (page_config) ->
      $scope.page_requirements = page_config?.sections ? []
      $scope.requirements = page_config?.validations ? {}

    $scope.loadPageConfig(ApplicationService.page_config[$scope.page])

    pusherAlreadyInitialized = () ->
      pusherClient &&
        typeof(ApplicationService.data?.config?.pusher) isnt "undefined" &&
        typeof(ApplicationService.data?.customer_application?.uuid) isnt "undefined"

    pusherClient = null

    unless pusherAlreadyInitialized() || applicationServiceDataMissing()
      pusherConfig = ApplicationService.data.config.pusher
      if pusherConfig.auth_url && pusherConfig.cluster && pusherConfig.key
        pusherParams = {}
        pusherParams['authEndpoint'] = pusherConfig.auth_url
        pusherParams['cluster'] = pusherConfig.cluster
        pusherClient = $pusher(new Pusher(pusherConfig.key, pusherParams))
        channel = pusherClient.subscribe("customer-app-#{ApplicationService.data.customer_application.uuid}")
        channel.bind 'close_guest_app', () ->
          $window.location.replace('/?reason=pushed_guest_app_closure') unless $scope.page == 'declined'
        channel.bind 'close_app', () ->
          $window.location.replace('/?reason=pushed_app_closure') unless $scope.page == 'declined'

    if $scope.requirements['income.additional_household_income']
      $scope.requirements['income.additional_household_income']['hide'] = true

    # ivars ex: ["person", "customer"]
    $scope.ivars = do ->
                      unless $scope.requirements?
                        []
                      else
                        all_keys = _.keys($scope.requirements).map((k) -> _.first(k.split('.')))
                        _.uniq(all_keys)

    angular.extend($scope, $controller('NeuroIdMixinCtrl', {$scope: $scope}))

    updateTimeout = null
    cancelUpdateTimeout = ->
      if updateTimeout
        $timeout.cancel(updateTimeout)
        updateTimeout = null

    $scope.closeAllLoadingModals = ->
      if $scope.useAmountLoadingSpinner
        $scope.closeAmountLoadingSpinner()
      else
        CustomerApplicationService.closeLoadingModal()

    $scope.closeAllLoadingModals()
    CustomerApplicationService.getIo()
    # $scope.customer_consent ||= {}
    $scope.serverSideErrors = ApplicationService.server_side_errors
    $scope.serverSideErrorMessages = []
    $scope.serverSideErrorFields = []
    $scope.submit_via_enter = false
    $scope.page_error = false
    $scope.new_promotion = coupon_code: null
    $scope.promotion_validation_error = null
    $scope.hasPromotions = ->
      $scope.promotions?.length > 0

    # POINT OF SALE DATA
    $scope.$watch "point_of_sale", (data) ->
      $rootScope.$broadcast("product:point_of_sale", data)

    # LEAD DATA START

    unless applicationServiceDataMissing()
      $scope.leadFirstVisit = ApplicationService.leadFirstVisit()
      $scope.shouldShowLeadsModal = ApplicationService.shouldShowLeadsModal() && _.contains(["personal", "personal_continued", "rates_terms"], $scope.page)
      $scope.leadInfoRequired = ApplicationService.leadInfoRequired()
      $scope.isOrganic = null # default
      $scope.leadWelcomeInfo = null # default

      getCardLeadDisplayName = (data) ->
        if data.customer_application?.product_type == "credit_card"
          # Unlike installment leads, credit card leads arrive via GET requests, so
          # they have to be handled differently
          cardLeadProviders = data.config.credit_card_landing_page_leads || {}
          # if found considered NOT organic
          cardLeadProviders[data.customer_application.source]?.display_name
        else
          # not a card product
          null

      computeLeadVariablesFromProgressData = (data) ->
        lead         = data.lead
        leadPrefill  = lead?.prefill
        leadPost     = lead?.post_lead
        hasLead      = leadPrefill || leadPost

        creditKarmaReferral = ['creditkarma-card', 'creditkarma', 'creditkarma_pnc_lightbox'].includes(data.customer_application?.source)
        cardLeadDisplayName = getCardLeadDisplayName(data)
        $scope.isOrganic = !hasLead && !creditKarmaReferral && !cardLeadDisplayName
        # Delete extendedWelcomeMessage and swap out for leadWithDefaultWelcome once Avant installment v5
        # is QA-able
        leadWithDefaultIntroArr = ['hsbc_avant_prefill', 'avant_digital_prescreen']
        $scope.extendedWelcomeMessage = !$scope.isOrganic && lead?.source not in leadWithDefaultIntroArr
        # Duplicating extendedWelcomeMessage, since we we are in the middle of the Avant v5 upgrade,
        # and these changes are not going through QA.
        $scope.leadWithDefaultIntro = lead?.source in leadWithDefaultIntroArr
        gtmLeadType  =  if creditKarmaReferral
                          'creditkarma'
                        else if cardLeadDisplayName
                          'card_referral'
                        else if leadPrefill
                          'prefill'
                        else if leadPost
                          'post'
                        else if $scope.isOrganic
                          'organic'
                        else
                          # should not happen
                          'unknown'
        # attach data to a namespace to be used by future events
        GoogleTagManagerService.extendEventData('application_page', { lead_type: gtmLeadType })

        if $scope.isOrganic
          $scope.leadWelcomeInfo = null
        else
          leadDisplayName = cardLeadDisplayName || (if creditKarmaReferral then 'Credit Karma' else (lead?.display_name))
          leadDisplayName = null if leadDisplayName is 'not_found'
          $scope.leadWelcomeInfo =
            leadProvider: leadDisplayName
            firstName: (data?.person.first_name)
            isPostLead: leadPost

      computeLeadVariablesFromProgressData(ApplicationService.data)

      # LEAD DATA END

      # GTM START
      gtmDataFromProgressData = (data) ->
        gtmData = {
                    acquisition_channel:          data.customer_application_metadata?.acquisition_channel
                    application_id:               data.customer_application.id
                    application_uuid:             data.customer_application.uuid
                    application_owner:            data.customer_application.application_owner
                    application_source:           data.customer_application.source
                    customer_id:                  data.customer.id
                    customer_uuid:                data.customer.uuid
                    lead_source:                  data.customer_application.lead_source
                    monthly_net_income:           data.income?.monthly_net_income
                    product_type:                 data.customer_application.product_type
                  }
                    # add in if they are an authenticated customer, need to change backend api
        if data.config?.locale == 'en-GB'
          angular.extend(gtmData,
            postcode:   (data.customer_address?.zip)
            title:      (data.person?.title)
          )

        gtmData

      # need to set the application properties first..before triggering the GTM events
      gtmData = gtmDataFromProgressData(ApplicationService.data)
      GoogleTagManagerService.extendEventData('legacy', gtmData)
      # attach data to a namespace to be used by future events
      GoogleTagManagerService.extendEventData('application_page', gtmData)

      # trigger GTM event (OLD)
      GoogleTagManagerService.sendProperties(
        event:      "pageview"
        virtualUrl: "#{ConfigService.viewPrefix}/#{$scope.productPrefix}#{$scope.page || 'undefined'}"
      )

      # trigger GTM event (OLD)
      GoogleTagManagerService.sendProperties(
        event:      "#{$scope.productPrefix}#{$scope.page}"
      )

      # trigger GTM event (NEW)
      # * notice this is WITH an eventData namespace (application_page), since we want to attach data to this event that we don't have all right here
      GoogleTagManagerService.fireEvent('application_pageview', {
        application_page: $scope.page
      }, 'application_page')

      # GTM END

    $scope.redirectIfDifferentPage = (response_data, callback) ->
      if response_data.new_application_id?
        $scope.$emit 'customer:redirect', true
        $window.location.replace(ConfigService.viewBaseUrl(response_data.new_application_id))
      else if $scope.page isnt response_data.page
        $scope.tealiumEvent("#{$scope.page}_submit", { application_page: $scope.page })
        CustomerApplicationService.goToStage(response_data.page)
      else
        callback()

    $scope.trackVisit = (properties={}) ->
      ApplicationService.track $scope.page

    $scope.$emit 'customer_application:submit', null

    # Piwik TV Tracking
    if typeof window._paq isnt "undefined"
      switch $scope.page
        when "personal" then window._paq.push(['trackGoal', 3])
        when "rates_terms" then window._paq.push(['trackGoal', 4])
        when "contract" then window._paq.push(['trackGoal', 5])
        when "bank_account" then window._paq.push(['trackGoal', 6])
        when "additional_information" then window._paq.push(['trackGoal', 7])

    assignServerSiderErrors = (errors) ->
      # This method should never be called directly from outside this file;
      # use `$scope.showServerSideErrors` instead.
      $scope.serverSideErrorFields = []
      serverErrorFieldNames = []
      for fields in errors
        for field, errorMessages of fields
          fieldName = field.replace(".", "_")
          serverErrorFieldNames.push(fieldName)
          form_field = "form.#{fieldName}"
          switch form_field
            when "form.person_date_of_birth"
              $scope.serverSideErrorFields.push field
              $scope.$eval("form.person_date_of_birth")?.$setValidity("server", false)
              for f in ["form.person_date_of_birth_month", "form.person_date_of_birth_day", "form.person_date_of_birth_year"]
                $scope.serverSideErrors.push f
                $scope.$eval(f)?.$setValidity("server", false)
            else
              $scope.serverSideErrors.push form_field
              $scope.serverSideErrorFields.push field
              evaluatedField = $scope.$eval(form_field)
              if evaluatedField
                evaluatedField.$setValidity "server", false
              else
          errorMessageField = "#{field}_server_errors"
          $scope.serverSideErrorMessages.push errorMessageField
          $parse(errorMessageField).assign($scope, errorMessages)
      $scope.addFieldErrorEvents("server", serverErrorFieldNames)
      $scope.scrollToTopError("server")

    $scope.showServerSideErrors = (errors) ->
      # Wrapper for `assignServerSiderErrors` that catches and redirects on
      # server-side errors that have a redirect URL. If more than one error
      # has a redirect URL, only the first one will be used.
      redirectUrl = null
      for fields in errors
        for field, errorMessages of fields
          if field == "customer.redirect"
            redirectUrl = errorMessages[0]
            break
        if redirectUrl? then break
      if redirectUrl?
        $scope.$emit 'customer:redirect', true
        $window.location.replace(redirectUrl)
      else
        assignServerSiderErrors(errors)

    $scope.showHiddenFieldsWithErrors = (fieldNames) ->
      for fieldName in fieldNames
        req = requirementIdentifier(fieldName)
        continue if !req
        showHiddenFieldWithError(req)

    requirementIdentifier = (fieldName) ->
      fieldNameArr = fieldName.split("_")
      result = []
      _.times fieldNameArr.length - 1, (n) ->
        i = 1
        possibleFieldName = _.reduce(fieldNameArr, (acc, str) ->
          sep = if i == n then "." else "_"
          i += 1
          acc + str + sep
        , "").slice(0, -1)
        result.push(possibleFieldName)
      req = _.find result, (r) -> $scope.requirements[r]

    showHiddenFieldWithError = (fieldName) ->
      requirement = $scope.requirements[fieldName]
      if requirement.error_display_group
        _.each(fieldsInErrorDisplayGroup(requirement.error_display_group), (field) ->
          $scope.requirements[field].hide = false
        )
      else
        $scope.requirements[fieldName].hide = false

    fieldsInErrorDisplayGroup = (groupName) ->
      reqs = _.filter(Object.entries($scope.requirements), (entry) ->
        entry[1].error_display_group == groupName
      )
      _.map(reqs, (req) -> req[0])

    $scope.addFieldErrorEvents = (errorType, fieldNames) ->
      if _.contains(["client", "server"], errorType) and _.isArray(fieldNames) and !_.isEmpty(fieldNames)
        try
          $scope.showHiddenFieldsWithErrors(fieldNames)
        catch error
          null

    $scope.clearServerSideErrors = ->
      try
        for field_name in $scope.serverSideErrors
          evaluatedField = $scope.$eval(field_name)
          if evaluatedField
            evaluatedField.$setValidity "server", true
        $parse(f).assign($scope, []) for f in $scope.serverSideErrorMessages
      catch error
        null

    $scope.noClientSideErrors = -> !$scope.form.$error.custom

    $scope.fireGtmSubmitEvent = ->
      # trigger GTM event (OLD)
      GoogleTagManagerService.sendProperties(
        event: "#{$scope.productPrefix}#{$scope.page}_submit"
      )
      # trigger GTM event (NEW)
      # * notice this is WITH an eventData namespace (application_page), since we want to attach data to this event that we don't have all right here
      GoogleTagManagerService.fireEvent('application_pagesubmit', {
        application_page: $scope.page
      }, 'application_page')

    # Angular 1.3 changed the way form validations work in a manner that causes
    # the fields to no longer be set to `$dirty` on submit. This is a hack
    # until we can get around to correctly using the new `$submitted` state.
    $scope.markFieldsDirty = ->
      angular.forEach($scope.form.$error.custom, (field) ->
        field.$setDirty()
        if [null, undefined, "null"].includes(field.$modelValue)
          field.$modelValue = ""

        if [null, undefined, "null"].includes(field.$viewValue)
          field.$viewValue = ""
        else if $scope.formWasAutofilled
          oldViewValue = field.$viewValue
          field.$setViewValue("")
          field.$setViewValue(oldViewValue)
      )

    $scope.submitWrapper = (onResponseCB) ->
      $scope.allowSaveFields = false
      $scope.clearInvalidData() if $scope.clearInvalidData?
      $scope.fireGtmSubmitEvent()
      $scope.markFieldsDirty()
      cancelUpdateTimeout()
      if $scope.submit_via_enter
        # allows forms to be able to not submit on enter keypress if desired
        $scope.submit_via_enter = false
        return
      $scope.checkValidations ->
        $scope.onValidationSuccess(onResponseCB)

    ensureValid = ->
      $rootScope.$broadcast 'customer_application:presubmit:validation', $scope.page
      if $scope.noClientSideErrors()
        $rootScope.$broadcast 'customer_application:presubmit:cleanup', $scope.page
        true
      else
        false

    $scope.checkValidations = (onSuccess, onError) ->
      if ValidationsRequiredHelper.withDictionary(ensureValid)
        onSuccess()
      else
        $scope.addFieldErrorEvents("client", _.pluck($scope.form.$error.custom, '$name'))
        $scope.scrollToTopError("custom")
        onError() if typeof onError is "function"

    $scope.onValidationSuccess = (onResponseCB) ->
      $scope.$emit 'customer_application:submit', $scope.page
      $rootScope.$broadcast('fetch_data:in_progress')
      if $scope.useAmountLoadingSpinner
        config = $scope.config?.version_config_data
        loadingMessage = AmountHelper.spinnerLoadingMessage(config, $scope.page)
        $scope.openAmountLoadingSpinner({ loadingMessage: loadingMessage })
      else
        CustomerApplicationService.createLoadingModal('Saving your application')
      data = $scope.updateAllData()
      page_submission = ApplicationService.submitPage($scope.page, data)
      neuroid_submission = $scope.submitNeuroIdTrackingDataIfEnabled()
      $q.all([page_submission, neuroid_submission]).then(([response_data]) ->
        $scope.clearServerSideErrors()
        onResponseCB(response_data)
        if response_data.server_side_errors and response_data.server_side_errors.length > 0
          $scope.allowSaveFields = true
      ).catch(() ->
        $scope.allowSaveFields = true
      ).finally -> $rootScope.$broadcast('fetch_data:complete')

    # only want on page load, don't move findCheckboxStatus() into ng-show!
    $scope.hide_checked_checkboxes = false
    $scope.pageSupportsCheckboxes = true
    $scope.alwaysShowCheckboxesOnThisPage = false

    findCheckboxStatus = ->
      return false if !$scope.pageSupportsCheckboxes
      return true if $scope.alwaysShowCheckboxesOnThisPage
      show = false
      if $scope.page isnt "personal"
        for k, v of $scope.requirements
          current_value = $scope.$eval(k)
          if v.checkbox is true
            if shouldShowCheckbox(v, current_value)
              show = true
            else
              $scope.requirements[k].hide = true
          else if v.required is 'if_customer_consent_required' and !current_value
            show = true
      else
        show = true
      show

    shouldShowCheckbox = (v, current_value) ->
      return (v.required is true and (!current_value or (typeof(v.hide) != 'undefined' && !v.hide))) or
             (v.required is "if_customer_certain_state" and !current_value and v.state is $scope.customer_address.state)

    $scope.show_checkboxes = ->
      findCheckboxStatus()

    $scope.scrollToTopError = (errorType) ->
      return unless $scope.form.$error[errorType]
      # a bit against angular's design pattern to reference dom elements
      # but can clean this up later, it'll work for now
      # Scott has already posted this in #namanic-devices. Twice.
      firstErrorTopOffSet = null
      firstErrorLeftOffSet = null

      $scope.errors = $.extend(true, [], $scope.form.$error[errorType])
      for field in $scope.errors
        field?.$setViewValue(field.$viewValue)
        topOffSet = $("[name='#{field.$name}']").offset()?.top
        leftOffSet = $("[name='#{field.$name}']").offset()?.left
        # First error closest to the top left of the page
        if firstErrorTopOffSet == null && firstErrorLeftOffSet == null
          firstErrorTopOffSet  = topOffSet
          firstErrorLeftOffSet = leftOffSet
          firstErrorFieldId    = field.$name
        else
          if topOffSet < firstErrorTopOffSet
            firstErrorTopOffSet  = topOffSet
            firstErrorLeftOffSet = leftOffSet
            firstErrorFieldId    = field.$name
          else if topOffSet == firstErrorTopOffSet && leftOffSet < firstErrorLeftOffSet
            firstErrorLeftOffSet = leftOffSet
            firstErrorFieldId    = field.$name

      if firstErrorTopOffSet
        $scope.scrollToErrorPosition(firstErrorTopOffSet - 120, firstErrorFieldId)

    $scope.scrollToErrorPosition = (position, fieldId = null, callback = null) ->
      $("html, body").clearQueue().animate
        scrollTop: position
      , 1000, ->
        $(".text-danger").pulse
          color: "white"
        ,
          duration: 300
          pulses: 2
        callback() if callback
      if fieldId
        if element = document.getElementById(fieldId)
          if element.nodeName == 'DIV'
            element.querySelector('input')?.focus()
          else
            document.getElementById(fieldId)?.focus()
        else if element = document.getElementsByName(fieldId)[0]
          element.focus()
      false

    buildUpdateValue = (updates, field) ->
      if /^\w+\.\w+$/.test(field)
        value = $scope.$eval(field)
        if typeof value is "undefined"
          console.warn("cannot buildUpdateValue for undefined field #{field}")
        else if fieldValueIsValid(field)
          keys = field.split(".")
          updates[keys[0]] ||= {}
          updates[keys[0]][keys[1]] = value
      else
        console.warn("unknown field format in buildUpdateValue: #{field}")

    fieldValueIsValid = (fieldName) ->
      fieldNameUnderscore = fieldName.replace(".", "_")
      # When autofill is used, $scope.form.$error.custom is set to false.
      # If the page has no form validations, like most contract pages,
      # $scope.form.$error.custom is undefined.
      return true unless $scope.form.$error.custom
      fieldErrors = $scope.form.$error.custom.find((el) ->
        el.$name == fieldNameUnderscore
      )
      !fieldErrors

    fieldNameForEvent = (event) ->
      event.target?.attributes?['ng-model']?.value ||
      event.target?.attributes?.ng_model?.value ||
      event.currentTarget?.attributes?['ng-model']?.value ||
      event.currentTarget?.attributes?.ng_model?.value

    updateData = {}
    $scope.update = (object) ->
      return unless $scope.allowSaveFields
      updates = {}
      objectType = Object.prototype.toString.call(object)
      switch objectType
        when "[object String]"
          buildUpdateValue(updates, object)
        when "[object Array]"
          for field in object
            buildUpdateValue(updates, field)
        when "[object Object]"
          buildUpdateValue(updates, fieldNameForEvent(object))
        else
          console.warn("unknown $scope.update argument #{objectType}", object)

      if lodash.isEmpty(updates)
        $q.reject('no updates to apply to updateData')
      else
        cancelUpdateTimeout()
        lodash.merge(updateData, updates)
        updateTimeout = $timeout(->
          delivering = updateData
          updateData = {}
          CustomerApplicationService.updateData(
            $scope.page, delivering, true
          ).then((response) ->
            new_boolean_gate_values = response.data.boolean_gates
            $scope.$emit('boolean_gates:data', new_boolean_gate_values) if new_boolean_gate_values
          ).catch((reason) ->
            console.warn("updateData failed, merging updates...", reason)
            updateData = lodash.merge({}, delivering, updateData)
          )
        , 1000)

    $scope.allowSaveFields = true

    $scope.updateSSN = (field_name) ->
      $scope.person.ssn = $("input[name='#{field_name}']").val()

    $scope.updateAllData = ->
      data = {}
      data[ivar] = $scope[ivar] for ivar in $scope.ivars
      data

    flatKeyList = (data) ->
      keys = []
      for outer, inner of data
        for field, _ of inner
          keys.push("#{outer}.#{field}")
      keys

    $scope.$on 'autofill:fill', (_, autofillBroadcast) ->
      $scope.formWasAutofilled = true
      if autofillBroadcast.data?
        keys = flatKeyList(autofillBroadcast.data)
        # TODO: Handle rejection
        $timeout(( -> $scope.update(keys).catch(angular.noop)), 250)

    $scope.shouldHideConsent = (object, property) ->
      try
        return false if $scope.alwaysShowCheckboxesOnThisPage ||
          ($scope.requirements["#{object}.#{property}"] && $scope.requirements["#{object}.#{property}"].force_show)
        isElementPristine = $scope.form["#{object}_#{property}"].$pristine
        isElementValueTruthy = !!$scope.$eval("#{object}.#{property}")
        isElementHidden = !!($scope.requirements["#{object}.#{property}"] && $scope.requirements["#{object}.#{property}"].hide)
        isElementLeadRequired = $scope.leadInfoRequired && isElementValueTruthy
        isAlreadyConsented = isElementValueTruthy && isElementPristine
        isElementHidden || (isElementLeadRequired && isElementPristine) || isAlreadyConsented
      catch error
        console.warn("Caught Exception in CustAppMixinCtrl for #{object} #{property}", error)
        false

    modalInstance = null

    $scope.showLeadsModal = ->
      if $scope.shouldShowLeadsModal
        ApplicationService.setLeadFirstVisit()
        if $scope.useAmountModal
          $scope.openAmountModal("lead_welcome", { leadInfoRequired: $scope.leadInfoRequired })
        else
          modalInstance = $modal.open(
            templateUrl: "/customer_application_renderer/modals/lead_welcome.html"
            controller: [
                "$scope", "$modalInstance", "data", ($scope, $modalInstance, data) ->
                  $scope.lead = data.lead
                  $scope.customer_application = data.customer_application
                  $scope.customer = data.customer
                  $scope.person = data.person
                  $scope.config = data.config
                  $scope.leadInfoRequired = data.leadInfoRequired
                  $scope.close = (reason) ->
                    $modalInstance.dismiss(reason)
                  true
              ]
            resolve:
              data: ->
                customer: $scope.customer
                customer_application: $scope.customer_application
                lead: $scope.lead
                person: $scope.person
                config: $scope.config
                leadInfoRequired: $scope.leadInfoRequired
          )
          modalInstance.result

    $scope.showLeadsModal()

    $scope.showHelpChat = (event) ->
      event.preventDefault()
      olark('api.box.expand')

    $scope.validatePromotion = (event, sectionToSubmit) ->
      event.preventDefault()
      $scope.promotion_validation_error = null
      $scope.promotion_result = null

      # return for blank input
      if !$scope.new_promotion?.coupon_code?.length > 0
        $scope.submitSection sectionToSubmit if sectionToSubmit
        return

      # Alert of already submitted code,
      # unless we're on a blur, in which case it's just annoying.
      if _.indexOf(_.pluck($scope.promotions, 'coupon_code'), $scope.new_coupon_code) >= 0
        alert("That coupon code has already been applied.") unless event and event.type is "blur"
        return
      if !/^[A-Za-z0-9]+$/.test($scope.new_promotion.coupon_code)
        $scope.promotion_validation_error = "The promotional code must only contain letters and numbers."
        return
      if !/^\d{9}$/.test($scope.person.ssn)
        # This will prevent customers from entering any code (even a promo code)
        # until the SSN has been entered. Promo codes don't need SSNs, but the
        # client has no way to know which type of code it is at this point.
        $scope.promotion_validation_error = "Please enter your 9-digit social security number above."
      else
        $scope.addPromotion()

    $scope.addPromotion = ->
      # The SSN would normally have been saved on blur, but in rare cases that
      # request may not have completed yet
      CustomerApplicationService.updateData(
        $scope.page, { person: { ssn: $scope.person.ssn } }, true
      ).then(() ->
        CustomerApplicationService.addPromotion($scope.new_promotion.coupon_code)
      ).then((response) ->
        if response.data.error
          $scope.promotion_result =
            type: 'error'
            message: response.data.error
          $scope.new_promotion.coupon_code = null
        else
          promotion = response.data.promotion
          $scope.promotion_result =
            type: 'success'
            message: promotion.application_message
          $scope.new_promotion.coupon_code = null
          $scope.promotions.push promotion
          $scope.hideAddPromoField = true if promotion.stop_rule_processing
      )

    $scope.removePromotion = (promotion) ->
      $scope.promotion_result = null
      CustomerApplicationService.removePromotion(promotion).then (response) ->
        if response.data.error
          $scope.promotion_result =
            type: 'error'
            message: response.data.error
        else
          $scope.promotion_result =
            type: 'success'
            message: response.data.message
          $scope.promotions = _.reject($scope.promotions, (p) -> p.coupon_code is promotion.coupon_code)

    acquisitionChannelSelection = ->
      $scope.customer_application_metadata.acquisition_channel

    isPromotionTypeRadio = ->
      $scope.promotions?.some((promo) => (promo.promotion_type == "radio"))

    $scope.checkToDisplayAmazonDisclaimer = ->
      acquisitionChannelSelection() == 'Radio' || isPromotionTypeRadio()

    $scope.showTrustpilotWidget = ->
      !!($window.Trustpilot && $scope.customer_application.show_trustpilot_widget)

    $scope.logout = ->
      AuthenticationService.logout()

    check_session_timeout = ->
      unless $scope.checkingSessionStatus || $scope.submitDisabled
        AuthenticationService.check_session_timeout({
          customer_application_id: ApplicationService.target_application_id()
        })

    $interval(check_session_timeout, AuthenticationService.session_timeout_check_interval)

    $scope.$on "checkingSessionStatus", (event, data) ->
      $scope.checkingSessionStatus = data

    if !ConfigService.useAmountCleaveForFormatting
      if $scope.person?
        $scope.$watch 'person.home_phone', ->
          $scope.person.home_phone = $filter('LocalePhoneNumber')($scope.person.home_phone, $scope.config.locale);
        $scope.$watch 'person.mobile_phone', ->
          $scope.person.mobile_phone = $filter('LocalePhoneNumber')($scope.person.mobile_phone, $scope.config.locale);
      if $scope.employer?
        $scope.$watch 'employer.phone_number', -> $scope.employer.phone_number = $filter('LocalePhoneNumber')($scope.employer.phone_number, $scope.config.locale);

    $timeout ->
      try
        # Initializes TrustPilot widget after the page has finished rendering
        $window.Trustpilot.Modules.WidgetManagement.findAndApplyWidgets()
      catch e
        # (not all locales support Trustpilot)

    if ConfigService.sidebar?.digicert && document.querySelectorAll("script[src='#{digitcertUrl}']").length == 0
      injectDigicert()
]
